<template>
    <div class="supplier-view">
      
      <div class="supplier-info">
        <div class="info-row">
          <div class="info-item">
            <label>Name</label> <!-- name == title -->
            <input type="text" v-model="supplier.title" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          <div class="info-item">
            <label>Nickname</label>
            <input type="text" v-model="supplier.nickname" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          <div class="info-item">
            <label>Address</label>
            <input type="text" v-model="supplier.address"   :disabled="!editMode" :class="{ 'enabled': editMode}"/>
          </div>
          
        </div>
        
        <div class="info-row">
          <div class="info-item">
            <label>Email</label>
            <input type="email" v-model="supplier.email" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          <div class="info-item">
            <label>Phone</label>
            <input type="text" v-model="supplier.phone" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          

          <div class="info-item">
            <label>Country</label>
            <input type="text" v-model="supplier.country" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          
        </div>
        
        <div class="info-row">
          
          <div class="info-item">
            <label>Τ.Κ.</label>
            <input type="text" v-model="supplier.postal"  :disabled="!editMode" :class="{ 'enabled': editMode}" />
          </div>
          <div class="info-item">
            <label>Occupation</label>
            <input type="text" v-model="supplier.occupation" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
         
          <div class="info-item">
            <label>ΑΦΜ</label>
            <input type="text" v-model="supplier.afm" :disabled="!editMode"  :class="{ 'enabled': editMode}"/>
          </div>
          
        </div>

        <div class="info-row " style="width:32.6%">
          
          <div class="info-item ">
            <label>ΔΟΥ</label>
            <input type="text"  v-model="supplier.doy" :disabled="!editMode"  :class="{ 'enabled': editMode}" />
          </div>
          
        </div>
      </div>
      
      <div class="actions">
        <button @click="cancelEdit" class="cancel-btn" v-if="editMode">CANCEL</button>
        <button @click="editsupplier" v-if="!editMode && (canEditSupplier || canEditAllSuppliers || superUser)" class="edit-btn">EDIT</button>
        <button class="save-btn" v-if="editMode" @click="save">SAVE</button>
      </div>
<br><br>

      <h4 class="fw-bolder">Supplier Contacts</h4>
        <table id="projectTable" class="table table-hover align-middle mb-0 mis_table" style="width:100%">
            <thead>
                <tr>
                    
                    <th style="width:23%;">
                        <div>Name</div>
                    </th>
                    <th style="width:17%;">
                        <div>Phone</div>
                    </th>
                    <th style="width:15%;">
                        <div>Email</div>
                    </th>
                    <th style="width:17%;">
                        <div>Address</div>
                    </th>
                    <th style="width:12%;">
                        <div>Postal Code</div>
                    </th>
                    <th style="width:12%;">
                        <div>AFM</div>
                    </th>
                    
                    <th class="no-after"></th>
                </tr>
            </thead>
             <tbody>
                <tr v-for="(contact, index) in supplier.contacts" :key="contact.id" v-if="superUser || canViewAllContacts || canViewContact(contact)">
                    
                    
                    <td>{{ contact.name || '' }}</td>
                    <td>{{ contact.phone || '' }}</td>
                    <td>{{ contact.email || '' }}</td>
                    <td>{{ contact.address || '' }}</td>

                    <td>{{ contact.postal || '' }}</td>

                   
                    <td>{{ contact.afm || '' }}</td>
                </tr>
                <tr v-if="!supplier.contacts || supplier.contacts.length === 0">
                    <td colspan="6" class="text-center">No contacts available</td>
                </tr>
            </tbody> 
        </table>
    </div>
  </template>
  
  <script>
  import { get, createOrUpdate } from '@/services/suppliers';
  import { useToast } from 'vue-toastification';
  import { mapGetters } from 'vuex';
  import 'vue-toastification/dist/index.css';

  export default {
    name: "Supplier",
    methods: {
        
    
        canViewContact(contact) {
         if (!contact) { return false; }
            return localStorage.getItem('current_user_id') == contact?.createdBy && this.userPermissionsContacts?.view === 1;
        }, 
     
        
       
    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission',

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissions() {
            return this.getUserPermission('Suppliers');
        },
        
        canEditAllSuppliers() {
            return this.userPermissions?.editAll === 1;
        },
        canCreateSupplier() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
            return this.userPermissions?.archive === 1;
        },
        canEditSupplier() {
         return localStorage.getItem('current_user_id') == this.supplier?.createdBy && this.userPermissions?.edit === 1;
      },
      userPermissionsContacts() {
            return this.getUserPermission('Contacts');
        },
        
      
        canViewAllContacts() {
            return this.userPermissionsContacts?.view === 1;
        },
    },
    data() {
      return {
        editMode: false,
        supplier: {
          id: null,
          title: '',
          address: '',
          email: '',
          occupation: '',
          postal: '',
          phone: '',
          doy: '',
          afm: '',
        }
      };
    },
    async mounted() {
        const supplierData = await get({id: this.$route.query.id});
        if (supplierData.data.success) {
            this.supplier = supplierData.data.data;
        }
    },
    methods: {
      /* canEditSupplier() {
        console.log(localStorage.getItem('current_user_id') == this.supplier?.createdBy);
        console.log(this.userPermissions?.edit);
        return localStorage.getItem('current_user_id') == this.supplier?.createdBy && this.userPermissions?.edit === 1;
      }, */
      async save() {
        const r = await createOrUpdate(this.supplier);
        if (r.data.success) {
            this.editMode = false;
            useToast().success(r.data.message);
        } else {
            useToast().error(r.data.message);
        }
      },
      editsupplier() {
        this.editMode = true;
      },
      cancelEdit() {
        this.editMode = false;
      },
    },
  };
  </script>
  
  <style scoped>
  .supplier-view {
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  .header {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .logo {
    height: 40px;
  }
  .supplier-info {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 20px;
  }
  .info-row {
    display: flex;
    gap: 10px;
  }
  .info-item {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  label{
    color:#606060;
    font-weight:bolder;
    size:20px;
  }
  input, textarea {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background: #EBEBEB;
  }
  .actions {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
  }
  .edit-btn, .cancel-btn {
    
    border: none;
    cursor: pointer;
    margin-right: 10px;
  }
  .edit-btn, .save-btn {
    background-color: #7F7F7F;
    color: white;
    font-weight:bolder;
    border:none;
    padding:10px;
    padding-left:20px;
    padding-right: 20px;
  }
  .cancel-btn {
    border:  #8C8C8C 2px solid;
    background: none;
    color:#8C8C8C;
    font-weight: bolder;
  }

  button{
    border-radius:5px;
  }

  .enabled{
    background-color: white;
  }
  
  </style>
  